import { APIModel } from './api-model.model'

export class APIBillingCode extends APIModel {
    billingCodeId: number;
    billingCode: number|null;
    billingCodeDescription: string|null;
    billingCodePrice: number;
    billingType: string;
    shortcodeId: number;
    billingCodeEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        billingCodeId: number;
        billingCode: number|null;
        billingCodeDescription: string|null;
        billingCodePrice: number;
        billingType: string;
        shortcodeId: number;
        billingCodeEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.billingCodeId = params.billingCodeId
        this.billingCode = params.billingCode
        this.billingCodeDescription = params.billingCodeDescription
        this.billingCodePrice = params.billingCodePrice
        this.billingType = params.billingType
        this.shortcodeId = params.shortcodeId
        this.billingCodeEnabled = params.billingCodeEnabled ? 1 : 0
    }
}
